<template>
  <a-card :bordered="false">
    <a-tabs default-active-key="1" @change="changeTabs" size="large" :tab-bar-style="{marginBottom: '24px', paddingLeft: '16px'}">
      <a-tab-pane loading="true" :tab="this.language['web.untreated']" key="1">
        <EmpDevAppApplyList ref="checkData" :handleStatus="0" v-if="this.hanldSatus==1"></EmpDevAppApplyList>
      </a-tab-pane>
      <a-tab-pane loading="true" :tab="this.language['web.processed']" key="2">
        <EmpDevAppApplyList ref="checkData" :handleStatus="1"  v-if="this.hanldSatus==2"></EmpDevAppApplyList>
      </a-tab-pane>
    </a-tabs>
  </a-card>
</template>

<script>
import '@/assets/less/TableExpand.less'
import EmpDevAppApplyList from './EmpDevAppApplyList'

export default {
  name: 'EmpDevAppAuditList',
  components: {
    EmpDevAppApplyList
  },
  data () {
    return {
      description: '审核页面',

      queryParam: {
        auditStatus: 'approving'
      },
      hanldSatus:1,
      dictOptions:{},
      superFieldList:[],
      applicationList:{},
      previewVisible: false,
      previewImage: '',
    }
  },
  created() {




  },
  computed: {
    language() {
      return this.$store.getters.language
    }
  },
  methods: {
    changeTabs(value){
      this.hanldSatus=value;
    }
  }
}
</script>
<style scoped>
@import '~@assets/less/common.less'
</style>